<template>
  <div
    class="columns ls-service-history-item--service-event"
    :class="{ 'ls-service-history-item--top-border': isFirst }"
  >
    <div class="column">
      <div class="columns is-mobile ls-service-history-item--center">
        <span class="column is-1">
          <LsIcon :type="iconDetails.type" :color="iconDetails.color" />
        </span>
        <span class="column is-11" test-id="date-text"> {{ dateText }} </span>
      </div>
    </div>
    <div class="column">
      <div
        class="columns is-mobile ls-service-history-item--center ls-service-history-item--star-row"
      >
        <span
          class="column ls-service-history-item--status"
          :class="'ls-service-history-item--' + iconDetails.color"
          test-id="status-text"
          >{{ event.status | titleCase }}</span
        >
        <span class="column">
          <LsButton
            v-if="event.is_reviewable && !event.reviews.length"
            track-id="service_history_item-rate_service"
            test-id="rate-service"
            text="rate service"
            :loading="isUpdating"
            @click="rateService({ scheduleEvent: event })"
          />
          <LsStars
            v-else-if="event.status === 'completed'"
            :value="starRating"
            size="lg"
            track-id="service_history_item-stars"
          />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { LsStars, LsIcon, LsButton } from '@/components/common';
import { lsDateHelpers, lsModalService } from 'ls-vue-common';
import { lsScheduleEventServiceItemHelpers } from '@/components/ServiceItems/LsScheduleEventServiceItem/LsScheduleEventServiceItemHelpers';
import { ReviewModal } from '@/modals';
import { PROPERTIES__GET_PROPERTIES_AND_SCHEDULES, SCHEDULES__GET_SCHEDULE } from '@/store/types';
import { mapActions } from 'vuex';

export default {
  name: 'ServiceHistoryItem',
  components: {
    LsIcon,
    LsStars,
    LsButton,
  },
  props: {
    event: VueTypes.shape({
      starts_at: VueTypes.string.isRequired,
      ends_at: VueTypes.string.isRequired,
      status: VueTypes.string.isRequired,
      reviews: VueTypes.array.isRequired,
      is_reviewable: VueTypes.bool.isRequired,
    }).isRequired.loose,
    isFirst: VueTypes.bool.def(false),
  },
  data() {
    return {
      isUpdating: false,
    };
  },
  computed: {
    iconDetails() {
      const { icon } = lsScheduleEventServiceItemHelpers.getScheduleEventServiceItemDisplayValues({
        scheduleEvent: this.event,
      });
      return icon;
    },
    dateText() {
      return lsDateHelpers.getDateRange({
        startDate: this.event.starts_at,
        endDate: this.event.ends_at,
      });
    },
    starRating() {
      return _.get(this.event, 'reviews[0].rating', 0);
    },
  },
  methods: {
    ...mapActions([PROPERTIES__GET_PROPERTIES_AND_SCHEDULES, SCHEDULES__GET_SCHEDULE]),
    async rateService({ scheduleEvent }) {
      this.isUpdating = true;
      await this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]();
      const { schedule, scheduleevent_id } = scheduleEvent;

      await this[SCHEDULES__GET_SCHEDULE]({
        property_id: schedule.property_id,
        schedule_id: schedule.schedule_id,
      });

      this.isUpdating = false;
      lsModalService.open({
        parent: this,
        component: ReviewModal,
        width: 760,
        props: {
          scheduleevent_id: scheduleevent_id,
          schedule_id: schedule.schedule_id,
          contractorFirstName: _.get(this.event, 'contractor.user.first_name'),
          tipMatchEligible: _.get(this.event, 'contractor.tier') === 'platinum',
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-service-history-item--service-event {
  align-items: center;
  border-bottom: 1px solid $primary-light;
}

.ls-service-history-item--top-border {
  border-top: 1px solid $primary-light;
}

.ls-service-history-item--center {
  align-items: center;
}

.ls-service-history-item--primary {
  color: $primary;
}

.ls-service-history-item--tertiary {
  color: $tertiary;
}

.ls-service-history-item--danger {
  color: $danger;
}

@media (min-width: $desktop) {
  .ls-service-history-item--service-event {
    height: 60px;
  }
}

@media (max-width: $mobile-max-width) {
  .ls-service-history-item--service-event {
    padding: 10px 0;
  }

  .ls-service-history-item--star-row :nth-child(1) {
    order: 2;
  }

  .ls-service-history-item--star-row :nth-child(2) {
    order: 1;
  }

  .ls-service-history-item--status {
    text-align: right;
  }
}
.themed-app {
  .ls-service-history-item--service-event {
    border-color: $theme-color-primary-light;
  }
  .ls-service-history-item--top-border {
    border-color: $theme-color-primary-light;
  }
  .ls-service-history-item--primary {
    color: $theme-color-primary;
  }
  .ls-service-history-item--tertiary {
    color: $theme-color-secondary;
  }
  .ls-service-history-item--danger {
    color: $theme-color-danger;
  }
}
</style>
